import { render } from "./Blogs.vue?vue&type=template&id=9473e020"
import script from "./Blogs.vue?vue&type=script&lang=js"
export * from "./Blogs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\vue.js-3\\service-provider-project\\service-provider\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__